import React, { Component } from 'react';
import { Input, Button, DatePicker, Select, Table, Modal } from 'antd';
import { withRouter } from 'react-router-dom';
import ukImg from '../../assets/img/database/uk.png'
import unImg from '../../assets/img/database/un.png'
import usImg from '../../assets/img/database/us.png'
import caImg from '../../assets/img/database/ca.png'
import ruImg from '../../assets/img/database/ru.png'
import frImg from '../../assets/img/database/fr.png'
import geImg from '../../assets/img/database/ge.png'
import plImg from '../../assets/img/database/polish.png'
import tuImg from '../../assets/img/database/turkish.png'
import indiaImg from '../../assets/img/database/indian.png'
import pakistaniImg from '../../assets/img/home/pakistani.png'
import singaporeanImg from '../../assets/img/home/singaporean.png'
import newzealandImg from '../../assets/img/home/newzealand.png'
import southafricanImg from '../../assets/img/home/southafrican.png'
import austrianImg from '../../assets/img/home/austrian.png'
import malaysianImg from '../../assets/img/home/malaysian.png'
import { commonSearchAPI } from '../../api/parl.js'
import '../../assets/css/common.css'
import './mycss.css'
import MyBreadcrumb from '../../components/MyBreadcrumb.jsx'

const { Search } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;

class ParlSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            heading: '',
            currCountry: this.props.match.params.country ? this.props.match.params.country : '',
            title: '',
            param_title: '',
            dateRange: [],
            type: '',
            yihuiCat: '',
            yihuiType: '',
            dataSource: [],
            loading: false,
            columns: [],
            value1: '',
            value2: '',
            value3: '',
            selectedRowKeys: [],
            total: 0,
            totalPage: 0,
            totalSelect: 0,
            pageSize: 10,
            pageNum: 1,
            keyword: '',
            speaker: '',
            orderBy: '',
            orderHow: '',
            category: '',
            parliament: '',
            session: '',
            isDownloadVisible: false,
            isAuthorityVisible: false,
            ukCol: [
                {
                    title: '日期(Date)',
                    dataIndex: 'date',
                    key: 'meeting_id',
                    width: 120,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,
                },
                {
                    title: '议院(Chamber)',
                    dataIndex: 'type',
                    width: 150,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,
                },
                {
                    title: '主议题(Major Heading)',
                    dataIndex: 'major_heading',
                    key: 'meeting_id',
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '子议题(Minor Heading)',
                    dataIndex: 'minor_heading',
                    key: 'meeting_id',
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '发言人(Speaker)',
                    dataIndex: 'speaker_name',
                    key: 'meeting_id',
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '详情',
                    dataIndex: '',
                    width: 80,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.meeting_id}>详情</a>
                    },
                },
                {
                    title: '下载',
                    dataIndex: '',
                    width: 80,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            usCol: [
                {
                    title: '日期(Date)',
                    dataIndex: 'date',
                    width: 100,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '众议院(House)',
                    dataIndex: 'house',
                    key: 'house',
                    width: 120,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '参议院(Senate)',
                    dataIndex: 'senate',
                    key: 'senate',
                    width: 120,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '期号(Issue No.)',
                    dataIndex: 'date_and_issue_no',
                    key: 'date_and_issue_no',
                    width: 100,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '每日摘要(Daily Digest)',
                    dataIndex: 'daily_digest',
                    key: 'daily_digest',
                    width: 120,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '备注扩展(Extensions of Remarks)',
                    dataIndex: 'extensions',
                    key: 'extensions',
                    width: 120,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '详情',
                    key: 'auto_id',
                    width: 60,
                    fixed: 'right',
                    render: (text, record) => {
                        // return <a target="_blank" href={record.pdf_url}>详情</a>
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.auto_id}>详情</a>
                    },
                }, {
                    title: '下载',
                    key: 'auto_id',
                    width: 80,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            caCol: [
                {
                    title: '日期(Date)',
                    dataIndex: 'date',
                    key: 'date',
                    width: 50,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '议院(Chamber)',
                    dataIndex: 'category',
                    key: 'category',
                    width: 60,
                    // sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '届(Parliament)',
                    dataIndex: 'parliament',
                    key: 'parliament',
                    width: 40,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '次(Session)',
                    dataIndex: 'session',
                    key: 'session',
                    width: 40,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '详情',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.auto_id}>详情</a>
                    },
                }, {
                    title: '下载',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            ruCol: [
                {
                    title: '日期(Date)',
                    dataIndex: 'date',
                    key: 'date',
                    width: 60,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '议院(Палата)',
                    dataIndex: 'category',
                    key: 'category',
                    width: 180,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '发布者(Разместил)',
                    dataIndex: 'post_by',
                    key: 'post_by',
                    width: 120,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '发布日期(Дата Размещения)',
                    dataIndex: 'post_date',
                    key: 'post_date',
                    width: 60,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '详情',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        // return <a target="_blank" href={record.document_url}>详情</a>
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.auto_id + '?tb_name=meeting'}>详情</a>
                    },
                }, {
                    title: '下载',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            euCol: [
                {
                    title: '日期(Date)',
                    dataIndex: 'date_str',
                    key: 'date_str',
                    width: 80,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '委员会(Committee)',
                    dataIndex: 'type',
                    key: 'type',
                    width: 100,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,
                    render: (text) => {
                        return text.replace(/\\n/g, '')
                    }
                },
                {
                    title: '标题(Title)',
                    dataIndex: 'title',
                    key: 'title',
                    width: 180,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '文档类型(Document Type)',
                    dataIndex: 'empl_value',
                    key: 'empl_value',
                    width: 100,
                    textWrap: 'word-break',
                    ellipsis: true
                },
                {
                    title: 'Pe Number',
                    dataIndex: 'pe_value',
                    key: 'pe_value',
                    width: 100,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '详情',
                    key: 'auto_id',
                    width: 60,
                    fixed: 'right',
                    render: (text, record) => {
                        // return <a target="_blank" href={record.pdf_url}>详情</a>
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.auto_id}>详情</a>
                    },
                }, {
                    title: '下载',
                    key: 'auto_id',
                    width: 60,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            frCol: [
                {
                    title: '日期(Date)',
                    dataIndex: 'date',
                    key: 'date',
                    width: 50,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '议院(Assemblée)',
                    dataIndex: 'category',
                    key: 'category',
                    width: 80,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '会期(Séance)',
                    dataIndex: 'type',
                    key: 'type',
                    width: 80,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '标题(Civilité)',
                    dataIndex: 'title',
                    key: 'title',
                    width: 180,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '详情',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.auto_id + '?tb_name=France'}>详情</a>
                    },
                }, {
                    title: '下载',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            geCol: [
                {
                    title: '日期(Date)',
                    dataIndex: 'date',
                    key: 'date',
                    width: 50,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '议院(Parlament)',
                    dataIndex: 'category',
                    key: 'category',
                    width: 80,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '标题(Titel)',
                    dataIndex: 'title',
                    key: 'title',
                    width: 180,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '详情',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.auto_id + '?tb_name=Germany'}>详情</a>
                    },
                }, {
                    title: '下载',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            plCol: [
                {
                    title: '日期(Date)',
                    dataIndex: 'date',
                    key: 'date',
                    width: 50,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '期(Posiedzenie)',
                    dataIndex: 'posiedzenie',
                    key: 'posiedzenie',
                    width: 180,
                    textWrap: 'word-break',
                    sorter: true,
                    ellipsis: true,

                },
                {
                    title: '详情',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.auto_id + '?tb_name=Pl'}>详情</a>
                    },
                },
                {
                    title: '下载',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            trCol: [
                {
                    title: '日期(Date)',
                    dataIndex: 'tarih',
                    key: 'tarih',
                    width: 50,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '标题(Başlıkları)',
                    dataIndex: 'title',
                    key: 'title',
                    width: 180,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '详情',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.auto_id + '?tb_name=TrTbmm'}>详情</a>
                    },
                }, {
                    title: '下载',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            pkCol: [
                {
                    title: '日期(Date)',
                    dataIndex: 'date',
                    key: 'date',
                    width: 120,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '议会类型(Category)',
                    dataIndex: 'category',
                    key: 'category',
                    width: 140,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,
                    render: (text) => {
                        if (text === 'Se') {
                            return 'Senate'
                        } else if (text === 'Na') {
                            return 'National Assembly'
                        } else {
                            return text
                        }
                    }
                },
                {
                    title: '年度(Parliamentary Year)',
                    dataIndex: 'parliamentaryyear',
                    key: 'parliamentaryyear',
                    width: 210,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '次(Session)',
                    dataIndex: 'session',
                    key: 'session',
                    width: 160,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '详情',
                    key: 'auto_id',
                    width: 50,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.auto_id + '?tb_name=Pk'}>详情</a>
                    },
                }, {
                    title: '下载',
                    key: 'auto_id',
                    width: 50,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            sgCol: [
                {
                    title: '日期(Date)',
                    dataIndex: 'date',
                    key: 'date',
                    width: 120,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '卷号(Volume)',
                    dataIndex: 'vol',
                    key: 'vol',
                    width: 120,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '标题(Title)',
                    dataIndex: 'title',
                    key: 'title',
                    width: 250,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '详情',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.auto_id + '?tb_name=Singapore'}>详情</a>
                    },
                }, {
                    title: '下载',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            nzCol: [

                {
                    title: '日期(Date)',
                    dataIndex: 'date',
                    key: 'date',
                    width: 100,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '标题(Title)',
                    dataIndex: 'title',
                    key: 'title',
                    width: 280,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },

                {
                    title: '文档类型(Document Type)',
                    dataIndex: 'documenttype',
                    key: 'documenttype',
                    width: 120,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '详情',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.auto_id + '?tb_name=NewZealand'}>详情</a>
                    },
                }, {
                    title: '下载',
                    key: 'auto_id',
                    width: 40,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            zaCol: [
                {
                    title: '日期(Date)',
                    dataIndex: 'date',
                    key: 'date',
                    width: 100,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '文件(File)',
                    dataIndex: 'name',
                    key: 'name',
                    width: 280,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '议会类型(House)',
                    dataIndex: 'house',
                    key: 'house',
                    width: 100,
                    textWrap: 'word-break',
                    sorter: true,
                    ellipsis: true,

                },
                {
                    title: '文档类型(Type)',
                    dataIndex: 'type',
                    key: 'type',
                    width: 110,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '语言(Language)',
                    dataIndex: 'language',
                    key: 'language',
                    width: 120,
                    sorter: true,
                    textWrap: 'word-break',

                },
                {
                    title: '详情',
                    key: 'auto_id',
                    width: 60,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.auto_id + '?tb_name=SouthAfrica'}>详情</a>
                    },
                }, {
                    title: '下载',
                    key: 'auto_id',
                    width: 60,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            atCol: [
                {
                    title: '日期(Date)',
                    dataIndex: 'date',
                    key: 'date',
                    width: 100,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '时期(Periode)',
                    dataIndex: 'period',
                    key: 'period',
                    width: 120,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '议院(Parlament)',
                    dataIndex: 'category',
                    key: 'category',
                    width: 140,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,
                },
                {
                    title: '会期(Sitzung)',
                    dataIndex: 'type',
                    key: 'type',
                    width: 90,
                    textWrap: 'word-break',
                    sorter: true,
                    ellipsis: true,

                },
                {
                    title: '类型(Typ)',
                    dataIndex: 'subject',
                    key: 'subject',
                    width: 280,
                    sorter: true,
                    textWrap: 'word-break',

                },
                {
                    title: '详情',
                    key: 'auto_id',
                    width: 60,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.auto_id + '?tb_name=Austria'}>详情</a>
                    },
                }, {
                    title: '下载',
                    key: 'auto_id',
                    width: 60,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            indiaCol: [
                {
                    title: '日期(Date)',
                    dataIndex: 'date',
                    key: 'date',
                    width: 100,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '议院(Sansad)',
                    dataIndex: 'category',
                    key: 'category',
                    width: 140,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,
                    render: (text) => {
                        if (text === 'LS') {
                            return 'Lok Sabha'
                        } else if (text === 'RS') {
                            return 'Rajya Sabha'
                        } else {
                            return text
                        }
                    }
                },
                {
                    title: '期(Session)',
                    dataIndex: 'session',
                    key: 'session',
                    width: 90,
                    textWrap: 'word-break',
                    sorter: true,
                    ellipsis: true,

                },

                {
                    title: '详情',
                    key: 'auto_id',
                    width: 50,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.auto_id + '?tb_name=India'}>详情</a>
                    },
                }, {
                    title: '下载',
                    key: 'auto_id',
                    width: 50,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            myCol: [
                {
                    title: '日期(Date)',
                    dataIndex: 'date',
                    key: 'date',
                    width: 100,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,

                },
                {
                    title: '议院(Dewan)',
                    dataIndex: 'category',
                    key: 'category',
                    width: 70,
                    sorter: true,
                    textWrap: 'word-break',
                    ellipsis: true,
                },
                {
                    title: '届(Parlimen)',
                    dataIndex: 'session',
                    key: 'session',
                    width: 110,
                    textWrap: 'word-break',
                    sorter: true,
                    ellipsis: true,

                },
                {
                    title: '期(Penggal)',
                    dataIndex: 'term',
                    key: 'term',
                    width: 70,
                    textWrap: 'word-break',
                    sorter: true,
                    ellipsis: true,

                },
                {
                    title: '次(Mesyuarat)',
                    dataIndex: 'meeting',
                    key: 'meeting',
                    width: 110,
                    textWrap: 'word-break',
                    sorter: true,
                    ellipsis: true,

                },
                {
                    title: '详情',
                    key: 'auto_id',
                    width: 50,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" href={'/database/parl/' + this.state.currCountry + '/detail/' + record.auto_id + '?tb_name=My'}>详情</a>
                    },
                }, {
                    title: '下载',
                    key: 'auto_id',
                    width: 50,
                    fixed: 'right',
                    render: (text, record) => {
                        return <a target="_blank" onClick={this.handleClickDownload} >下载</a>
                    },
                }
            ],
            dailyDigest: '',
            extensions: '',
            house: '',
            senate: '',
        }
    }

    setTitle = () => {
        this.setState({
            title: {
                'uk': '英国议会', 'us': '美国议会', 'ca': '加拿大议会', 'eu': '欧洲议会', 'ru': '俄罗斯杜马', 'fr': '法国议会',
                'ge': '德国议会', 'pl': '波兰议会', 'tr': '土耳其议会',
                'pk': '巴基斯坦议会', 'sg': '新加坡议会', 'nz': '新西兰议会', 'za': '南非议会', 'at': '奥地利议会', 'india': '印度议会', 'my': '马来西亚议会',
                '': null
            }[this.state.currCountry]
        })
        this.setState({
            countrySrc: {
                'uk': ukImg, 'us': usImg, 'ca': caImg, 'eu': unImg, 'ru': ruImg, 'fr': frImg, 'ge': geImg,
                'pl': plImg, 'tr': tuImg, 'pk': pakistaniImg, 'sg': singaporeanImg, 'nz': newzealandImg, 'za': southafricanImg, 'at': austrianImg, 'india': indiaImg, 'my': malaysianImg,
            }[this.state.currCountry]
        })
    }

    componentDidMount() {
        this.setTitle()
        this.handleSearch(this.state.keyword)
    }

    // 时间选择器 onChange
    handleRangePicker = (date, dateString) => {
        this.setState({ dateRange: dateString }, () => {
            this.newHandleSearch(this.state.keyword)
        })
    }

    // 议会类型 onChange
    handleSelectType = (value) => {
        this.setState({ type: value }, () => {
            this.newHandleSearch(this.state.keyword)
        })
    }

    handleChangeValue1 = (e) => {
        this.setState({ value1: e.target.value })
        //点击清空小图标,清空input时触发查询
        if (e.type === 'click' && e.target.value === '') {
            this.newHandleSearch(this.state.keyword)
        }
    }

    handleChangeValue2 = (e) => {
        this.setState({ value2: e.target.value })
        //点击清空小图标,清空input时触发查询
        if (e.type === 'click' && e.target.value === '') {
            this.newHandleSearch(this.state.keyword)
        }
    }
    handleChangeValue3 = (e) => {
        this.setState({ value3: e.target.value })
        //点击清空小图标,清空input时触发查询
        if (e.type === 'click' && e.target.value === '') {
            this.newHandleSearch(this.state.keyword)
        }
    }

    handleSelectYiHuiCat = (value) => {
        this.setState({ yihuiCat: value }, () => {
            this.newHandleSearch(this.state.keyword)
        })
    }

    handleSelectYiHuiType = (value) => {
        this.setState({ yihuiType: value }, () => {
            this.newHandleSearch(this.state.keyword)
        })
    }


    newHandleSearch = () => {
        this.setState({ pageNum: 1 }, () => {
            this.handleSearch(this.state.keyword)
        })
    }

    // 一框式搜索
    handleSearch = (text) => {
        const { ukCol, usCol, euCol, ruCol, caCol, frCol, geCol, plCol, trCol, pkCol, sgCol, nzCol, zaCol, atCol, indiaCol, myCol } = this.state
        this.setState({ loading: true }, () => {

            let columns = {
                'us': usCol, 'ca': caCol, 'ru': ruCol, 'eu': euCol, 'uk': ukCol, 'fr': frCol, 'ge': geCol, 'pl': plCol, 'tr': trCol,
                'pk': pkCol, 'sg': sgCol, 'nz': nzCol, 'za': zaCol, 'at': atCol, 'india': indiaCol, 'my': myCol
            }[this.state.currCountry]
            let data = {}
            let date = this.state.dateRange ? this.state.dateRange.join(',') : ''
            if (this.state.currCountry === 'uk') {
                data = {
                    type: this.state.type,
                    date: date,
                    heading: this.state.value2,
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum,
                    speaker_name: this.state.value1,
                }
            }
            else if (this.state.currCountry === 'ca') {
                data = {
                    date: date,
                    category: this.state.category,
                    parliament: this.state.parliament,
                    session: this.state.session,
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum,

                }
            }
            else if (this.state.currCountry === 'eu') {
                data = {
                    date: date,
                    title: this.state.value1,
                    // post_by: this.state.speaker,                                                                                     
                    type: this.state.type,
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum,
                }
            }
            else if (this.state.currCountry === 'fr') {
                data = {
                    date: date,
                    title: text,
                    // post_by: this.state.speaker,                                                                                     
                    tb_name: 'France',
                    type: this.state.yihuiType,
                    category: this.state.yihuiCat,
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum,
                }
            }
            else if (this.state.currCountry === 'ge') {
                data = {
                    date: date,
                    title: text,
                    // post_by: this.state.speaker,                                                                                     
                    tb_name: 'Germany',
                    category: this.state.yihuiCat,
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum,
                }

            }
            else if (this.state.currCountry === 'pl') {
                data = {
                    date: date,
                    posiedzenie: text,
                    // post_by: this.state.speaker,                                                                                     
                    tb_name: 'Pl',
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum
                }
                this.setState({ yihuiType: 'Pl' })
            }

            else if (this.state.currCountry === 'tr') {
                data = {
                    tarih: date,
                    title: text,
                    // post_by: this.state.speaker,                                                                                     
                    tb_name: 'TrTbmm',
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum
                }
                this.setState({ yihuiType: 'TrTbmm' })
            }
            else if (this.state.currCountry === 'pk') {
                if (this.state.yihuiType !== '') {
                    date = this.state.yihuiType
                }
                data = {
                    date: date,
                    // post_by: this.state.speaker,                                                                                     
                    tb_name: 'Pk',
                    category: this.state.yihuiCat,
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum
                }
            }
            else if (this.state.currCountry === 'sg') {
                if (this.state.yihuiType !== '') {
                    date = this.state.yihuiType
                }
                data = {
                    date: date,
                    // post_by: this.state.speaker,                                                                                     
                    tb_name: 'Singapore',
                    title: text,
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum
                }

            }
            else if (this.state.currCountry === 'nz') {
                if (this.state.yihuiType !== '') {
                    date = this.state.yihuiType
                }
                data = {
                    date: date,
                    // post_by: this.state.speaker,                                                                                     
                    tb_name: 'NewZealand',
                    title: text,
                    documenttype: this.state.yihuiCat,
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum
                }
            }
            else if (this.state.currCountry === 'za') {

                data = {
                    date: date,
                    // post_by: this.state.speaker,                                                                                     
                    tb_name: 'SouthAfrica',
                    name: text,
                    house: this.state.type,
                    category: this.state.yihuiCat,
                    language: this.state.yihuiType,
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum
                }

            }
            else if (this.state.currCountry === 'at') {

                data = {
                    date: date,
                    // post_by: this.state.speaker,                                                                                     
                    tb_name: 'Austria',
                    subject: text,
                    category: this.state.yihuiCat,
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum
                }

            }
            else if (this.state.currCountry === 'india') {
                data = {
                    date: date,
                    // post_by: this.state.speaker,                                                                                     
                    tb_name: 'India',
                    category: this.state.yihuiCat,
                    session: this.state.yihuiType,
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum
                }
            }
            else if (this.state.currCountry === 'ru') {
                data = {
                    date: date,
                    tb_name: 'meeting',
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum
                }

            }
            else if (this.state.currCountry === 'us') {
                data = {
                    date: date,
                    // tb_name: 'meeting',
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum
                }

            }
            else if (this.state.currCountry === 'my') {
                data = {
                    date: date,
                    tb_name: 'My',
                    category: this.state.yihuiCat,
                    session: this.state.yihuiType,
                    // meeting:'',
                    term: this.state.type,
                    page_size: this.state.pageSize,
                    page_num: this.state.pageNum
                }

            }


            if (this.state.speaker && this.state.speaker.length > 0) {
                data.speaker_name = this.state.speaker
            }

            if (this.state.orderBy && this.state.orderBy.length > 0) {
                data.order_by = this.state.orderBy
                data.order = this.state.orderHow && this.state.orderHow.length > 0 ? this.state.orderHow.slice(0, -3) : ''
            }

            let curCtry = this.state.currCountry
            commonSearchAPI(curCtry, data)
                .then(res => {
                    document.body.scrollTop = 0; // For Safari
                    document.documentElement.scrollTop = 0;
                    let resData = res.data.data.data
                    if (curCtry === 'uk') {
                        resData.map(item => {
                            item.major_heading = item.major_heading_names.replace(/\\n/g, '')
                            item.minor_heading = item.minor_heading_names.replace(/\\n/g, '')
                            item.speaker_name = item.speaker_names
                            item.auto_id = item.meeting_id
                            return item
                        })
                    }
                    this.setState({
                        dataSource: res.data.data.data,
                        total: res.data.data.total,
                        totalPage: res.data.data.page_info.total_page,
                        keyword: text,
                        loading: false,
                        columns: columns,
                        totalSelect: 0,
                        selectedRowKeys: [],
                    })
                })
                .catch(err => {
                    this.setState({ loading: false })
                })
        })

    }

    handleDownload = () => {
        this.setState({ isAuthorityVisible: true })
    }

    handleClickDownload = () => {
        this.setState({ isDownloadVisible: true })
    }

    handleSelectChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys, totalSelect: selectedRowKeys.length });
    };

    handlePageSizeChange = (current, pageSize) => {
        this.setState({ pageSize: pageSize, pageNum: current }, () => {
            this.handleSearch(this.state.keyword)
        })
    }

    handlePageNumChange = (pageNum) => {
        this.setState({ pageNum }, () => {
            this.handleSearch(this.state.keyword)
        })
    }

    handleTableChange = (pagination, filters, sorter, extra) => {
        console.log(pagination, '页码改变时')
        if (sorter) {
            this.setState({ orderBy: sorter.field, orderHow: sorter.order }, () => {
                this.handleSearch(this.state.keyword)
            })
        }
    }

    handleClose = () => {
        this.setState({ isAuthorityVisible: false })
    }

    // handleChange = (e) => {
    //     this.setState({ speaker: e.target.value })
    // }

    render() {
        const { title, dataSource, columns, selectedRowKeys, total, totalPage, totalSelect, currCountry, loading, countrySrc, isDownloadVisible, isAuthorityVisible } = this.state

        const rowSelection = { selectedRowKeys, onChange: this.handleSelectChange, fixed: true };

        const rangePickerEle = (
            <RangePicker onChange={this.handleRangePicker} style={{ width: `calc(25% - 10px)`, minWidth: 240, marginTop: 10, paddingTop: 6, marginRight: 10 }} className="picker-border" placeholder="始终" />
        )

        const ukEle = (
            // <div style={{ float: 'right', display: 'inline-block', width: `calc(50% - 20px)`, marginLeft: 20 }}>
            //     <span style={{ color: '#333333', marginTop: 8, }}>类型：</span>
            <Select style={{ width: `calc(20% - 10px)`, marginLeft: 10, marginRight: 10 }} placeholder="Chamber"
                onChange={this.handleSelectType} allowClear>
                <Option value="">All</Option>
                <Option value="commons">commons</Option>
                <Option value="lords">lords</Option>
            </Select>
            // </div>
        )

        const frEle = (
            <>
                <Select style={{ width: `calc(20% - 10px)`, marginRight: 10 }} placeholder="Assemblée"
                    onChange={this.handleSelectYiHuiCat} allowClear>
                    <Option value="">All</Option>
                    <Option value="Assemblee">Assemblée Nationale</Option>
                    <Option value="Senat">Sénat</Option>
                </Select>

                <Select style={{ width: `calc(20% - 10px)`, marginRight: 10 }} placeholder="Séance"
                    onChange={this.handleSelectYiHuiType} allowClear>
                    {/* <Option value="Assemblee">Session ordinaire</Option>
                <Option value="Senat">Session extraordinaire</Option> */}
                    <Option value="">All</Option>
                    <Option value="1e séance">1e séance</Option>
                    <Option value="2e séance">2e séance</Option>
                    <Option value="3e séance">3e séance</Option>
                    <Option value="Première séance">Première séance</Option>
                    <Option value="Séance unique">Séance unique</Option>
                </Select>
            </>
        )

        const geEle = (
            // <div style={{ float: 'right', display: 'inline-block', width: `calc(50% - 20px)`, marginLeft: 20 }}>
            //     <span style={{ color: '#333333', marginTop: 8, }}>类型：</span>

            <>
                <Select style={{ width: `calc(20% - 10px)`, marginRight: 10 }} placeholder="Parlament"
                    onChange={this.handleSelectYiHuiCat} allowClear>
                    <Option value="">All</Option>
                    <Option value="Bundestag">Bundestag</Option>
                    <Option value="Bundesrat">Bundesrat</Option>
                </Select>

            </>
            // </div>
        )

        const pkEle = (
            <>
                <Select style={{ width: `calc(20% - 10px)`, marginRight: 10 }} placeholder="Category"
                    onChange={this.handleSelectYiHuiCat} allowClear>
                    <Option value="">All</Option>
                    <Option value="Se">Senate</Option>
                    <Option value="Na">National Assembly</Option>
                </Select>

                <Select style={{ width: `calc(30% - 10px)`, marginRight: 10 }} placeholder="Parliamentary Year"
                    onChange={this.handleSelectYiHuiType} allowClear>
                    <Option value="">All</Option>
                    <Option value="2009-01-01,2009-12-31">Seventh Parliamentary Year 2009-2010</Option>
                    <Option value="2010-01-01,2010-12-31">Eighth Parliamentary Year 2010-2011</Option>
                    <Option value="2011-01-01,2011-12-31">Ninth Parliamentary Year 2011-2012</Option>
                    <Option value="2012-01-01,2012-12-31">Tenth Parliamentary Year 2012-2013</Option>
                    <Option value="2013-01-01,2013-12-31">Eleventh Parliamentary Year 2013-2014</Option>
                    <Option value="2014-01-01,2014-12-31">Twelfth Parliamentary Year 2014-2015</Option>
                    <Option value="2015-01-01,2015-12-31">Thirteenth Parliamentary Year 2015-2016</Option>
                    <Option value="2016-01-01,2016-12-31">Fourteenth Parliamentary Year 2016-2017</Option>
                    <Option value="2017-01-01,2017-12-31">Fifteenth Parliamentary Year 2017-2018</Option>
                    <Option value="2018-01-01,2018-12-31"> Sixteenth Parliamentary Year 2018-2019</Option>
                    <Option value="2019-01-01,2019-12-31">Seventeenth Parliamentary Year 2019-2020</Option>
                    <Option value="2020-01-01,2020-12-31">Eighteenth Parliamentary Year 2020-2021</Option>
                    <Option value="2021-01-01,2021-12-31">Nineteenth Parliamentary Year 2021-2022</Option>
                    <Option value="2022-01-01,2022-12-31">Twentieth Parliamentary Year 2022-2023</Option>
                </Select>
            </>
        )

        const sgEle = (
            <>
                <Select style={{ width: `calc(30% - 10px)`, marginRight: 10 }} placeholder="Parliament"
                    onChange={this.handleSelectYiHuiType} allowClear>
                    <Option value="">All</Option>
                    <Option value="1965-12-08,1968-02-08">1st(1965-12-08 To 1968-02-08)</Option>
                    <Option value="1968-05-06,1972-08-16">2nd(1968-05-06 To 1972-08-16)</Option>
                    <Option value="1972-10-12,1976-12-06">3rd(1972-10-12 To 1976-12-06)</Option>
                    <Option value="1977-02-07,1980-12-04">4th(1977-02-07 To 1980-12-04)</Option>
                    <Option value="1981-02-03,1984-12-03">5th(1981-02-03 To 1984-12-03)</Option>
                    <Option value="1985-02-25,1988-08-16">6th(1985-02-25 To 1988-08-16)</Option>
                    <Option value="1989-01-09,1991-08-13">7th(1989-01-09 To 1991-08-13)</Option>
                    <Option value="1992-01-06,1996-12-15">8th(1992-01-06 To 1996-12-15)</Option>
                    <Option value="1997-05-26,2001-10-17">9th(1997-05-26 To 2001-10-17)</Option>
                    <Option value="2002-03-25,2006-04-20">10th(2002-03-25 To 2006-04-20)</Option>
                    <Option value="2006-11-02,2011-04-19">11th(2006-11-02 To 2011-04-19)</Option>
                    <Option value="2011-10-10,2015-08-25">12th(2011-10-10 To 2015-08-25)</Option>
                    <Option value="2016-01-15,2020-06-23">13th(2016-01-15 To 2020-06-23)</Option>
                    <Option value="2020-08-24,2024-10-31">14th(2020-08-24 To Present)</Option>
                </Select>
            </>
        )

        const nzEle = (
            <>
                <Select style={{ width: `calc(20% - 10px)`, marginRight: 10 }} placeholder="Document Type"
                    onChange={this.handleSelectYiHuiCat} allowClear>
                    <Option value="">All</Option>
                    <Option value="Daily">Daily</Option>
                    <Option value="Event">Event</Option>
                    <Option value="Question">Question</Option>
                    <Option value="Speech">Speech</Option>
                    <Option value="Vote">Vote</Option>
                </Select>
                <Select style={{ width: `calc(30% - 10px)`, marginRight: 10 }} placeholder="Parliament"
                    onChange={this.handleSelectYiHuiType} allowClear>
                    <Option value="">All</Option>
                    <Option value="2002-01-01,2004-12-31">47(2002-2005)</Option>
                    <Option value="2005-01-01,2007-12-31">48(2005-2008)</Option>
                    <Option value="2008-01-01,2010-12-31">49(2008-2011)</Option>
                    <Option value="2011-01-01,2013-12-31">50(2011-2014)</Option>
                    <Option value="2014-01-01,2016-12-31">51(2014-2017)</Option>
                    <Option value="2017-01-01,2019-12-31">52(2017-2020)</Option>
                    <Option value="2020-01-01,2025-12-31">53(2020 Onwards)</Option>
                </Select>
            </>
        )

        const zaEle = (
            <>
                {/* <Select style={{ width: `calc(20% - 10px)`, marginLeft: 10, marginRight: 10 }} placeholder="Category"
                    onChange={this.handleSelectYiHuiCat} allowClear>
                    <Option value="">All</Option>
                    <Option value="HP">National Assembly</Option>
                    <Option value="Bills">National Council of Provinces</Option>
                </Select> */}
                <Select style={{ width: `calc(20% - 10px)`, marginRight: 10 }} placeholder="House"
                    onChange={this.handleSelectType} allowClear>
                    <Option value="">All</Option>
                    <Option value="EPC">EPC</Option>
                    <Option value="JOINT">JOINT</Option>
                    <Option value="NA">NA</Option>
                    <Option value="NCOP">NCOP</Option>
                </Select>
                <Select style={{ width: `calc(20% - 10px)`, marginRight: 10 }} placeholder="Language"
                    onChange={this.handleSelectYiHuiType} allowClear>
                    <Option value="">All</Option>
                    <Option value="ENG">ENG</Option>
                    <Option value="NDE">NDE</Option>
                    <Option value="SEP">SEP</Option>
                    <Option value="SOT">SOT</Option>
                    <Option value="SWA">SWA</Option>
                    <Option value="TSO">TSO</Option>
                    <Option value="TSW">TSW</Option>
                    <Option value="VEN">VEN</Option>
                    <Option value="XHO">XHO</Option>
                    <Option value="ZUL">ZUL</Option>
                </Select>
            </>
        )

        const atEle = (
            <>
                <Select style={{ width: `calc(20% - 10px)`, marginLeft: 10, marginRight: 10 }} placeholder="Parlament"
                    onChange={this.handleSelectYiHuiCat} allowClear>
                    <Option value="">All</Option>
                    <Option value="NR">NR</Option>
                    <Option value="BR">BR</Option>
                </Select>
            </>
        )

        const indiaEle = (
            <>
                <Select style={{ width: `calc(20% - 10px)`, marginRight: 10 }} placeholder="Sansad"
                    onChange={this.handleSelectYiHuiCat} allowClear>
                    <Option value="">All</Option>
                    <Option value="LS">Lok Sabha</Option>
                    <Option value="RS">Rajya Sabha</Option>
                </Select>
                <Select style={{ width: `calc(30% - 10px)`, marginRight: 10 }} placeholder="Session"
                    onChange={this.handleSelectYiHuiType} allowClear>
                    <Option value="">All</Option>
                    <Option value="259">259</Option>
                    <Option value="258">258</Option>
                    <Option value="257">257</Option>
                    <Option value="256">256</Option>
                    <Option value="255">255</Option>
                    <Option value="254">254</Option>
                    <Option value="253">253</Option>
                    <Option value="252">252</Option>
                    <Option value="251">251</Option>
                    <Option value="250">250</Option>
                    <Option value="249">249</Option>
                    <Option value="248">248</Option>
                    <Option value="247">247</Option>
                    <Option value="246">246</Option>
                    <Option value="245">245</Option>
                    <Option value="244">244</Option>
                    <Option value="243">243</Option>
                    <Option value="242">242</Option>
                    <Option value="241">241</Option>
                    <Option value="240">240</Option>
                    <Option value="239">239</Option>
                    <Option value="238">238</Option>
                    <Option value="237">237</Option>
                    <Option value="236">236</Option>
                    <Option value="235">235</Option>
                    <Option value="234">234</Option>
                    <Option value="233">233</Option>
                    <Option value="232">232</Option>
                    <Option value="231">231</Option>
                    <Option value="230">230</Option>
                    <Option value="229">229</Option>
                    <Option value="228">228</Option>
                    <Option value="227">227</Option>
                    <Option value="226">226</Option>
                    <Option value="225">225</Option>
                    <Option value="224">224</Option>
                    <Option value="223">223</Option>
                    <Option value="222">222</Option>
                    <Option value="221">221</Option>
                    <Option value="220">220</Option>
                    <Option value="219">219</Option>
                    <Option value="218">218</Option>
                    <Option value="217">217</Option>
                    <Option value="216">216</Option>
                    <Option value="215">215</Option>
                    <Option value="214">214</Option>
                    <Option value="213">213</Option>
                    <Option value="212">212</Option>
                    <Option value="211">211</Option>
                    <Option value="210">210</Option>
                    <Option value="209">209</Option>
                    <Option value="208">208</Option>
                    <Option value="207">207</Option>
                    <Option value="206">206</Option>
                    <Option value="205">205</Option>
                    <Option value="204">204</Option>
                    <Option value="203">203</Option>
                    <Option value="202">202</Option>
                    <Option value="201">201</Option>
                    <Option value="200">200</Option>
                    <Option value="199">199</Option>
                    <Option value="198">198</Option>
                    <Option value="197">197</Option>
                    <Option value="196">196</Option>
                    <Option value="195">195</Option>
                    <Option value="194">194</Option>
                    <Option value="193">193</Option>
                    <Option value="192">192</Option>
                    <Option value="191">191</Option>
                    <Option value="190">190</Option>
                    <Option value="189">189</Option>
                </Select>
            </>
        )

        const myEle = (
            <>
                <Select style={{ width: `calc(20% - 10px)`, marginRight: 10 }} placeholder="Dewan"
                    onChange={this.handleSelectYiHuiCat} allowClear>
                    <Option value="">All</Option>
                    <Option value="Dewan Negara">Dewan Negara</Option>
                    <Option value="Dewan Rakyat">Dewan Rakyat</Option>
                </Select>
                <Select style={{ width: `calc(30% - 10px)`, marginRight: 10 }} placeholder="Parlimen"
                    onChange={this.handleSelectYiHuiType} allowClear>
                    <Option value="">All</Option>
                    <Option value="Parlimen Kedua Belas (2008 - 2012)">Parlimen Kedua Belas (2008 - 2012)</Option>
                    <Option value="Parlimen Kelapan (1991 - 1994)">Parlimen Kelapan (1991 - 1994)</Option>
                    <Option value="Parlimen Kelima (1978 - 1982)">Parlimen Kelima (1978 - 1982)</Option>
                    <Option value="Parlimen Kesembilan (1995 - 1999)">Parlimen Kesembilan (1995 - 1999)</Option>
                    <Option value="Parlimen Kesebelas (2004 - 2007)">Parlimen Kesebelas (2004 - 2007)</Option>
                    <Option value="Parlimen Ketiga (1971 - 1974)">Parlimen Ketiga (1971 - 1974)</Option>
                    <Option value="Parlimen Keempat (1975 - 1978)">Parlimen Keempat (1975 - 1978)</Option>
                    <Option value="Parlimen Ketiga Belas (2013 - 2018)">Parlimen Ketiga Belas (2013 - 2018)</Option>
                    <Option value="Parlimen Keenam (1982 - 1985)">Parlimen Keenam (1982 - 1985)</Option>
                    <Option value="Parlimen Ketujuh (1986 - 1990)">Parlimen Ketujuh (1986 - 1990)</Option>
                    <Option value="Parlimen Keempat Belas (2018 - 2022)">Parlimen Keempat Belas (2018 - 2022)</Option>
                    <Option value="Parlimen Kesepuluh (1999 - 2003)">Parlimen Kesepuluh (1999 - 2003)</Option>
                    <Option value="Parlimen Pertama (1959 - 1964)">Parlimen Pertama (1959 - 1964)</Option>
                    <Option value="Parlimen Kedua (1964 - 1969)">Parlimen Kedua (1964 - 1969)</Option>
                    <Option value="Parlimen Kelima Belas (2022 - Sekarang)">Parlimen Kelima Belas (2022 - Sekarang)</Option>
                </Select>
                <Select style={{ width: `calc(20% - 10px)`, marginRight: 10 }} placeholder="Penggal"
                    onChange={this.handleSelectType} allowClear>
                    <Option value="">All</Option>
                    <Option value="Penggal Kelima">Penggal Kelima</Option>
                    <Option value="Penggal Keempat">Penggal Keempat</Option>
                    <Option value="Penggal Pertama">Penggal Pertama</Option>
                    <Option value="Penggal Kedua">Penggal Kedua</Option>
                    <Option value="Penggal Ketiga">Penggal Ketiga</Option>
                    <Option value="Penggal Keenam">Penggal Keenam</Option>
                </Select>
            </>
        )

        let searchEle = <></>

        if (currCountry === 'uk') {
            searchEle = ukEle
        }
        if (currCountry === 'fr') {
            searchEle = frEle
        }
        if (currCountry === 'ge') {
            searchEle = geEle
        }
        if (currCountry === 'pk') {
            searchEle = pkEle
        }
        if (currCountry === 'sg') {
            searchEle = sgEle
        }
        if (currCountry === 'nz') {
            searchEle = nzEle
        }
        if (currCountry === 'za') {
            searchEle = zaEle
        }
        if (currCountry === 'at') {
            searchEle = atEle
        }
        if (currCountry === 'india') {
            searchEle = indiaEle
        }
        if (currCountry === 'my') {
            searchEle = myEle
        }
        const tableEle = (
            <div style={{ padding: '20px 0' }}>
                <span style={{ marginTop: 10, display: 'inline-block' }}>
                    已选 <strong style={{ color: '#144db9' }}>{totalSelect}</strong> 条，
                    <span>共 <strong style={{ color: '#144db9' }}>{totalPage}</strong> 页，</span>
                    <strong style={{ color: '#144db9' }}>{total}</strong> 条结果
                </span>

                <Button className="btn-download" onClick={this.handleDownload} style={{ float: 'right' }}>批量下载</Button>
                <Table className="tbl-res"
                    locale={{ emptyText: ' ' }} loading={{ tip: "数据加载中 ...", spinning: loading }}
                    dataSource={dataSource} columns={columns}
                    scroll={{ x: '100%', scrollToFirstRowOnChange: true }}
                    rowKey={record => record.auto_id} rowSelection={rowSelection}
                    onChange={this.handleTableChange}
                    pagination={{ current: this.state.pageNum, showQuickJumper: true, total: total, onChange: this.handlePageNumChange, onShowSizeChange: this.handlePageSizeChange, showSizeChanger: true, position: ['bottomCenter'] }}
                    tableLayout="fixed"
                    style={{ margin: '20px 0', width: '100%' }}
                    sortDirections={['ascend', 'descend', 'ascend']} />
            </div>
        )

        const downloadEle = (
            <Modal title="温馨提示" open={isDownloadVisible}
                onCancel={() => { this.setState({ isDownloadVisible: false }) }}
                footer={[
                    <Button key="submit" type="primary" onClick={() => { this.setState({ isDownloadVisible: false }) }}> 确定 </Button>
                ]}
            >
                <p>如需下载，请您与我们联系 parliament_whu@163.com.</p>
            </Modal>
        )

        const authorityEle = (
            <Modal title="温馨提示" open={isAuthorityVisible}
                onCancel={this.handleClose}
                footer={[
                    <Button key="submit" type="primary" onClick={this.handleClose}> 确定 </Button>
                ]}
            >
                <p>如需下载，请您与我们联系 parliament_whu@163.com.</p>
            </Modal>
        )

        const ukInput = (
            <div style={{ marginTop: 20 }}>
                <Input allowClear placeholder="Speaker" size="large" onChange={this.handleChangeValue1} onPressEnter={this.newHandleSearch} style={{ width: `calc(20%)`, marginRight: 10, }} />
                <Input allowClear placeholder="Heading" size="large" onChange={this.handleChangeValue2} onPressEnter={this.newHandleSearch} style={{ width: `calc(20%)`, marginRight: 10, }} />
                {/* <Input allowClear placeholder="发言内容" size="large" onChange={this.handleChangeValue3} onPressEnter={this.newHandleSearch} style={{ width: `calc(20%)`, marginRight: 10, }} /> */}
                <Button className="btn-submit" style={{ verticalAlign: 'top' }} onClick={this.newHandleSearch} >搜索</Button>
            </div>
        )

        const frInput = (
            <>
                <Search className="search" allowClear placeholder="Civilité" size="large" onSearch={this.newHandleSearch} style={{ width: `calc(35% - 10px)`, marginTop: 20, borderRadius: 8, }} />
            </>
        )

        const geInput = (
            <>
                <Search className="search" allowClear placeholder="Titel" size="large" onSearch={this.newHandleSearch} style={{ width: `calc(35% - 10px)`, marginTop: 20, borderRadius: 8, }} />
            </>
        )

        const plInput = (
            <>
                {/* <Search className="search" allowClear placeholder="Posiedzenie" size="large" onSearch={this.handleSearch} style={{ width: `calc(30% - 10px)`, marginTop: 20, marginLeft: 10, borderRadius: 8, }} />             */}
            </>
        )

        const trInput = (
            <>
                <Search className="search" allowClear placeholder="Başlıkları" size="large" onSearch={this.newHandleSearch} style={{ width: `calc(30% - 10px)`, marginTop: 20, borderRadius: 8, }} />
            </>
        )

        const sgInput = (
            <>
                <Search className="search" allowClear placeholder="Title" size="large" onSearch={this.newHandleSearch} style={{ width: `calc(30% - 10px)`, marginTop: 20, borderRadius: 8, }} />
            </>
        )

        const nzInput = (
            <>
                <Search className="search" allowClear placeholder="Title" size="large" onSearch={this.newHandleSearch} style={{ width: `calc(30% - 10px)`, marginTop: 20, borderRadius: 8, }} />
            </>
        )

        const zaInput = (
            <>
                <Search className="search" allowClear placeholder="File" size="large" onSearch={this.newHandleSearch} style={{ width: `calc(30% - 10px)`, marginTop: 20, borderRadius: 8, }} />
            </>
        )

        const atInput = (
            <>
                <Search className="search" allowClear placeholder="Typ" size="large" onSearch={this.newHandleSearch} style={{ width: `calc(30% - 10px)`, marginTop: 20, borderRadius: 8, }} />
            </>
        )

        // const usInput = (
        //     <>
        //         <Input className="search" allowClear placeholder="Daily Digest" size="large" onChange={(e) => {this.setState({dailyDigest: e.target.value})}} style={{ width: `calc(50% - 10px)`, marginTop: 20, borderRadius: 8, }} />
        //         <Input className="search" allowClear placeholder="Extensions" size="large" onChange={(e) => {this.setState({extensions: e.target.value})}} style={{ width: `calc(50% - 10px)`, marginLeft: 10, marginTop: 20, borderRadius: 8, }} />
        //         <Input className="search" allowClear placeholder="House" size="large" onChange={(e) => {this.setState({house: e.target.value})}} style={{ width: `calc(50% - 10px)`, marginTop: 20, borderRadius: 8, }} />
        //         <Search className="search" allowClear placeholder="Senate" size="large" onSearch={this.handleSearch} style={{ width: `calc(50% - 10px)`, marginTop: 20, marginLeft: 10, borderRadius: 8, }} />
        //     </>
        // )

        const caInput = (
            <>
                <Input className="search" allowClear placeholder="Chamber" size="large" onChange={this.handleChangeValue1} onPressEnter={this.newHandleSearch} style={{ width: `calc(20% - 10px)`, marginTop: 20, borderRadius: 8, marginRight: 10, }} />
                <Input className="search" allowClear placeholder="Parliament" size="large" onChange={this.handleChangeValue2} onPressEnter={this.newHandleSearch} style={{ width: `calc(20% - 10px)`, marginTop: 20, marginRight: 10, borderRadius: 8, }} />
                <Search className="search" allowClear placeholder="Session" size="large" onSearch={this.newHandleSearch} style={{ width: `calc(30% - 10px)`, marginTop: 20, borderRadius: 8, }} />
            </>
        )

        const euInput = (
            <>
                {/* <Input className="search" allowClear placeholder="Speaker" size="large" onChange={(e) => {this.setState({speaker_name: e.target.value})}} style={{ width: `calc(20% - 10px)`, marginTop: 20 ,borderRadius: 8, }} /> */}
                <Input className="search" allowClear placeholder="Title" size="large" onChange={this.handleChangeValue1} onPressEnter={this.newHandleSearch} style={{ width: `calc(20% - 10px)`, marginTop: 20, marginRight: 10, borderRadius: 8, }} />
                <Search className="search" allowClear placeholder="Committee" size="large" onChange={(e) => { this.setState({ type: e.target.value }) }} onSearch={this.newHandleSearch} style={{ width: `calc(30% - 10px)`, marginTop: 20, marginRight: 10, borderRadius: 8, }} />
                {/* <Search className="search" allowClear placeholder="Speaker" size="large" onChange={(e) => {this.setState({speaker: e.target.value})}} onSearch={this.handleSearch} style={{ width: `calc(25% - 10px)`, marginTop: 20, marginLeft: 10,borderRadius: 8, }} /> */}
            </>
        )

        const inputEle = {
            'eu': euInput, 'uk': ukInput, 'ca': caInput, 'fr': frInput, 'ge': geInput, 'pl': plInput,
            'tr': trInput, 'sg': sgInput, 'nz': nzInput, 'za': zaInput, 'at': atInput
        }[currCountry]
        // 'us': usInput
        return (
            <div style={{ margin: '40px 15%', }}>
                <MyBreadcrumb urls={[
                    { breadcrumbName: title + '数据库' },
                ]} />
                <div className="major-heading" style={{ textAlign: 'left', color: '#144db9', fontSize: 18 }}>
                    <img src={countrySrc} alt="" style={{ marginRight: 10, marginTop: -4, height: 18 }} />
                    {title}
                </div>

                <div style={{ marginTop: 4, width: '80%', }}>

                    <div>{inputEle}</div>
                    <div>
                        {rangePickerEle}
                        {searchEle}
                    </div>
                </div>
                {tableEle}
                {downloadEle}
                {authorityEle}
            </div>
        );
    }
}

export default withRouter(ParlSearch)
